import { Button } from 'antd'
import { useCIMSTableContext } from '../../../CIMSTableContext'

function ReloadHeaderActionButton<T extends object>() {
  const { actions, loading } = useCIMSTableContext<T>()
  return (
    <Button
      disabled={loading}
      loading={loading}
      onClick={() => actions.header.onReload?.()}
    >
      Reload
    </Button>
  )
}

export default ReloadHeaderActionButton
